import React, { useRef, useState, useEffect } from "react";
import { closeIcon2 } from "../../assets";

const ModalContainer = ({ children, modalBackButton = {}, closeModal }) => {
  const modalRef = useRef(null);
  const startY = useRef(0);
  const [dragDistance, setDragDistance] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const onClickBackFunctionRef = useRef(null);

  useEffect(() => {
    if (modalBackButton?.show) {
      onClickBackFunctionRef.current = modalBackButton.onClick;
    }
  }, [modalBackButton]);

  const onBack = () => {
    if (onClickBackFunctionRef.current) {
      onClickBackFunctionRef.current();
    }
  };

  const handleTouchStart = (e) => {
    startY.current = e.touches[0].clientY;
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const currentY = e.touches[0].clientY;
    const distance = currentY - startY.current;

    if (distance > 0) {
      // Prevent pull-to-refresh
      e.preventDefault();
      setDragDistance(distance);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    if (dragDistance > 100) {
      closeModal("drag");
    } else {
      setDragDistance(0); // Animate back
    }
  };

  return (
    <div
      className="modalcontainer"
      role="dialog"
      aria-modal="true"
      onClick={() => closeModal("overlay")}
    >
      <div
        className="modalwrapper"
        ref={modalRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onClick={(e) => e.stopPropagation()}
        style={{
          transform:
            dragDistance > 0 ? `translateY(${dragDistance}px)` : "none",
          transition: !isDragging ? "transform 0.2s ease-out" : "none",
          touchAction: "none", // disable default touch behavior
        }}
      >
        <div className="auth-form-header">
          <div>
            {modalBackButton.show && (
              <button
                className="back-button"
                onClick={onBack}
                aria-label="Go Back"
              >
                <i className="fa fa-circle-arrow-left" aria-hidden="true"></i>
              </button>
            )}
          </div>
          <span
            className="close"
            onClick={(e) => {
              e.stopPropagation();
              closeModal("cancel");
            }}
          >
            {closeIcon2}
          </span>
        </div>
        {children}
      </div>
    </div>
  );
};

export default ModalContainer;
